import { ArrowLeft, Check, Loader2 } from "lucide-react";
import DataConsentDisclaimer from "@/components/DataConsentDisclaimer";
import { PrivacyNote } from "./FormPrimitives";
import { AgeRangeField, QuestionField, InvitedByField } from "./StepTwoFields";

const SubmitRow = ({ submitting, onBack, onSubmit }) => (
  <div className="flex gap-3">
    <button
      data-testid="registration-back-button"
      onClick={onBack}
      className="inline-flex items-center justify-center gap-2 h-14 px-5 rounded-xl border border-[rgba(17,42,67,0.15)] text-[#112A43] font-semibold hover:bg-[rgba(17,42,67,0.04)] transition-colors"
    >
      <ArrowLeft size={18} /> Back
    </button>
    <button
      data-testid="registration-submit-button"
      onClick={onSubmit}
      disabled={submitting}
      className="flex-1 inline-flex items-center justify-center gap-2 h-14 rounded-xl bg-[#F7B838] text-[#071524] font-semibold hover:bg-[#FFD16F] transition-colors active:scale-[0.99] disabled:opacity-70"
    >
      {submitting ? (<><Loader2 size={18} className="animate-spin" /> Reserving...</>) : (<>Reserve My Seat <Check size={18} /></>)}
    </button>
  </div>
);

// Step 2: personalisation (age range, question, invited-by) + consent + submit.
export const StepTwo = ({
  registration,
  form,
  errors,
  onField,
  referralCode,
  adviserName,
  questionPrefilled = false,
  consent,
  consentError,
  onConsentChange,
  submitting,
  onBack,
  onSubmit,
}) => (
  <div data-testid="registration-step-2" className="space-y-5">
    <AgeRangeField
      options={registration.ageRanges}
      value={form.age_range}
      error={errors.age_range}
      onChange={(v) => onField("age_range", v)}
    />
    <QuestionField
      prompts={registration.questionPrompts || []}
      value={form.biggest_question}
      prefilled={questionPrefilled}
      onChange={(v) => onField("biggest_question", v)}
    />
    <InvitedByField
      referralCode={referralCode}
      adviserName={adviserName}
      value={form.invited_by}
      onChange={(v) => onField("invited_by", v)}
    />
    <DataConsentDisclaimer checked={consent} onChange={onConsentChange} error={consentError} />
    <SubmitRow submitting={submitting} onBack={onBack} onSubmit={onSubmit} />
    <PrivacyNote />
  </div>
);
